import { render } from "./DsoStep2Registration.vue?vue&type=template&id=60047c2a&scoped=true"
import script from "./DsoStep2Registration.vue?vue&type=script&lang=js"
export * from "./DsoStep2Registration.vue?vue&type=script&lang=js"

import "./DsoStep2Registration.vue?vue&type=style&index=0&id=60047c2a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60047c2a"]])

export default __exports__